import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { VerifyOTPKeyResponse } from './verifyOTPKey.types'

export const verifyOtpKey: MutationFn<{ token: string }, VerifyOTPKeyResponse> = (
  client,
  { token }: { token: string }
) => client.post('v1/auth/otp-verify', { token }).then(a => a.data)
